import { IPagination, IPagingResponse } from 'interface/base.interface';
import axiosClient from './axiosClient';

const CabinetApi = {
  getCabinet: (params?: IPagination): Promise<IPagingResponse<any>> => {
    return axiosClient.get('abe/cabinet', { params });
  },
};
export default CabinetApi;
